import React, { useEffect, useState } from "react";
import IncomeChart from "../../IncomeChart/IncomeChart";
import ClientsBySource from "./ClientsBySource";
import AnalyticsCards from "./AnalyticsCards";
import NetPromoterScore from "./NetPromoterScore";
import TopServicesStats from "./TopServicesStats";
import ByWorkers from "./ByWorkers";
import { REST_API_URL } from "../../api/config";

const API_URL = REST_API_URL;

const getUserTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const buildHeaders = (token, additionalHeaders = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...additionalHeaders,
  };
  
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  
  const timezone = getUserTimeZone();
  if (timezone) {
    headers["User-Timezone"] = timezone;
  }
  
  return headers;
};

export default function Analytics() {
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    if (!token) return;

    const fetchUserType = async () => {
      try {
        const headers = buildHeaders(token);
        
        const res = await fetch(`${API_URL}/auth/userinfo/`, {
          headers,
        });
        
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setUserType(data?.user?.status || null);
      } catch (err) {
        console.error("❌ Error fetching user type:", err);
      }
    };

    fetchUserType();
  }, []);

  const showByWorkers = userType === "salon";
  const middleCols = showByWorkers ? 3 : 2;

  return (
    <main className="flex flex-1 flex-col bg-[#f9fafc] w-full">
       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="col-span-2 bg-white p-6 rounded-xl shadow">
          <IncomeChart />
        </div>

        <div className="lg:col-span-1">
          <ClientsBySource />
        </div>
      </div>

      <div className={`grid grid-cols-1 lg:grid-cols-${middleCols} gap-6 mb-6 w-full`}>
        <div className="bg-white rounded-xl shadow">
          <TopServicesStats />
        </div>
        <div className="bg-white rounded-xl shadow">
          <NetPromoterScore />
        </div>
        {showByWorkers && (
          <div className="bg-white rounded-xl shadow">
            <ByWorkers />
          </div>
        )}
      </div>

      <div className="w-full">
        <AnalyticsCards />
      </div>
    </main>
  );
}